// extracted by mini-css-extract-plugin
export default {"root":"CustomButton_root__YirR5"};